module.exports = __webpack_public_path__ + "a4ac96a233fc834d3fd4fc5b48790a5c.svg";